import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { REGISTERED_APPS } from '../../shared/types/Apps';
import { handleDiscounts } from '../../shared/utils/discounts';
import cleanupCartData from '../../utils/cart-cleanup';
import captureException from '../../utils/sentry';
import { logError } from '../../shared/utils/logging';
import { AppInfoCandyRack } from 'src/types';

let root: Root | null = null;

export default function init(
  shouldRenderApp = true,
  candyrackAppsInfo: AppInfoCandyRack,
) {
  try {
    let productHandle = '';
    const productHandleMatch =
      window.location.pathname.match(/.*\/products\/(.+)/);
    if (productHandleMatch) {
      productHandle = productHandleMatch[1];
    }

    if (!productHandleMatch && window.CANDYRACK_PRODUCT_HANDLE) {
      productHandle = window.CANDYRACK_PRODUCT_HANDLE;
    }

    const zipifyProductDataElement = document.querySelector<HTMLElement>(
      '[data-zp-product-init]',
    );
    if (zipifyProductDataElement) {
      try {
        productHandle = JSON.parse(zipifyProductDataElement.innerText).product
          .handle;
      } catch (error) {
        logError(
          'Zipify page identified, but handle lookup failed.',
          REGISTERED_APPS.CANDYRACK,
          error,
        );
      }
    }

    if (
      !productHandleMatch &&
      window.__shgProducts &&
      Object.keys(window.__shgProducts).length > 0
    ) {
      productHandle = Object.keys(window.__shgProducts)[0];
    }

    let rootElement = document.getElementById('candyrack-root');

    if (!rootElement) {
      document.body.insertAdjacentHTML(
        'beforeend',
        '<div id="candyrack-root"></div>',
      );
      rootElement = document.getElementById('candyrack-root');
    }

    // Do not render app on cart page - not needed
    if (shouldRenderApp && rootElement) {
      import(/* webpackPreload: true */ '../../CandyRackApp').then(
        ({ default: CandyRackApp }) => {
          if (root) {
            root.unmount();
          }

          root = createRoot(rootElement!);
          root.render(
            <CandyRackApp
              productHandle={productHandle}
              storefrontAccessToken={candyrackAppsInfo.storefront_access_token}
              useDSRecommEngine={
                candyrackAppsInfo?.use_ds_recomm_engine ?? false
              }
            />,
          );
        },
      );
    }

    if (candyrackAppsInfo.is_discount_message_enabled) {
      handleDiscounts(REGISTERED_APPS.CANDYRACK);
    }
    cleanupCartData(REGISTERED_APPS.CANDYRACK);
  } catch (error) {
    logError(error, REGISTERED_APPS.CANDYRACK);
    captureException(error as Error);
  }
}
